/**
 * The default time that GIFs will be displayed on the tile.
 */
export const GIF_DEFAULT_TIMEOUT = 5000;
/**
 * The prefix for formatted GIF messages.
 */
export const GIF_PREFIX = 'gif[';
